import React from 'react';

const DocumentMetadata = ({
  items = [],
  className,
  itemClassName,
  labelClassName,
  valueClassName,
  ariaLabel = 'Document details',
  labelElement: LabelElement = 'span'
}) => {
  const visibleItems = items.filter((item) => item && item.hidden !== true);
  if (!visibleItems.length) return null;

  return (
    <div className={className} aria-label={ariaLabel}>
      {visibleItems.map((item, index) => (
        <div className={itemClassName} key={item.key || `${item.label}-${index}`}>
          <LabelElement className={labelClassName}>{item.label}</LabelElement>
          <span className={valueClassName}>{item.value ?? '—'}</span>
        </div>
      ))}
    </div>
  );
};

export default DocumentMetadata;
